import { type PaymentMethod } from '~shared/types';

const findMatchingPaymentMethod = (
  paymentMethods: PaymentMethod[],
  paymentMethodID: number | null | undefined,
): PaymentMethod | null | undefined => paymentMethods.find((paymentMethod) => paymentMethodID === paymentMethod.id);

export default findMatchingPaymentMethod;
